import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { InwardMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchAllPONumbers, fetchPOData } from '../../Store/PHPSlice/Purchase/PoNo';
import { selectAllPONumbers, selectCloths, selectFirm, selectlocationdata, selectLumpBarcode, selectParty, selectPINos, selectPOData, selectRack, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData, fetchTransportData } from '../../Store/PHPSlice/Transport';
import { createPurInwEntry, fetchPINo } from '../../Store/PHPSlice/Inward/PurchaseInward';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import Dropdown from '../FieldsComponents/Dropdown';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { fetchLumpBarcode } from '../../Store/PHPSlice/Cutting/clothIssue';
import LumpMtrTbl from './LumpMtrTbl';
import { FaArrowRightLong } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import './BaleDetails.css';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import RadioComponent from '../FieldsComponents/RadioComponent';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';


const DirectPIEntry2 = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        tQtyM: '',
        PoId: '',
        firmId: '',
        amt: '',
        PiNo: '',
        vender: '',
        partyId: '',
        taxAmt: '',
        fAmt: '',
        lrdt: '',
        lrno: '',
        transpt: '',
        bill: '',
        locId: '',
        currentClothNm: '',
        ordtype: 'Manual',
        state_type: '',
        userId: userdata?.ID
    });
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [openBale, setOpenBale] = useState(false);
    const [noOfBales, setNoOfBales] = useState(0);
    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const [baleRows, setBaleRows] = useState([]);
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [lumpId, setLumpId] = useState(null);
    const [baleLump, setBaleLump] = useState('');
    const [totalMtr, setTotalMtr] = useState(0);
    const [barcodeLump, setBarcodeLump] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [openLumpDetails, setLumpDetails] = useState(false);
    const [openBaleBox, setOpenBaleBox] = useState(false);

    const [solist, setSolist] = useState([]);

    const dispatch = useDispatch();
    const polist = useSelector(selectPOData);
    const transptList = useSelector(selectTransports);
    const onlyPonos = useSelector(selectAllPONumbers);
    const PiNo = useSelector(selectPINos);
    const racklist = useSelector(selectRack);
    const loclist = useSelector(selectlocationdata);
    const lumpbar = useSelector(selectLumpBarcode);
    const clothList = useSelector(selectCloths);
    const partyList = useSelector(selectParty);
    const firmList = useSelector(selectFirm);
    const actionMap = {
        cloth: fetchClothData,
        vender: fetchPartyData
        // Add more mappings if needed
    };
    const [openDropdowns, setOpenDropdowns] = useState({});
    useEffect(() => {
        dispatch(fetchClothData());
        dispatch(fetchTransportData());
        dispatch(fetchAllPONumbers());
        dispatch(fetchPINo());
        dispatch(fetchRackData());
        dispatch(fetchLocationData());
        dispatch(fetchLumpBarcode());
        dispatch(fetchRackData());
        dispatch(fetchPartyData());
        dispatch(fetchCompanyData());
        fetchSaleorderdata();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);
    useEffect(() => {
        if (PiNo.data) {
            var Pi = PiNo.data.piNo;
            setFormData((prevFormData) => ({
                ...prevFormData,
                PiNo: Pi
            }));
        }
    }, [PiNo]);

    const fetchSaleorderdata = async () => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getSaleorderNoPurchaseOrderCloth`);
            const data = res?.data?.data || [];
            setSolist(data);
        } catch (error) {
            console.log('error', error);
        }
    };


    const fetchClothDataSOno = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getClothDataPOclothusingSOID&soId=${id}`);
            const data = res.data?.data;
            return data;
        } catch (error) {
            console.log('error', error);
        }
    };

    // console.log(formData.PoId);

    // useEffect(() => {
    //     if (formData.PoId) {
    //         // const selectPos = polist?.data?.filter(item => item.ID === formData.PoId);
    //         const selectPos = polist?.info;
    //         console.log(selectPos);

    //         if (selectPos) {
    //             const newData = selectPos
    //                 .filter(selectPo => parseFloat(selectPo.balMtr) > 0) // only include balMtr > 0
    //                 .map(selectPo => ({
    //                     netAmt: parseFloat(selectPo.Amount) + parseFloat(selectPo.igstAmt) + parseFloat(selectPo.cgstAmt) + parseFloat(selectPo.sgstAmt),
    //                     poInfoId: selectPo.poInfoId,
    //                     cloth: selectPo.cloth,
    //                     clothId: selectPo.clothId,
    //                     rate: selectPo.rate,
    //                     qty: selectPo.balMtr,
    //                     inwQty: selectPo.balMtr,
    //                     balQty: '0',
    //                     amount: selectPo.Amount,
    //                     IGST: selectPo.igst,
    //                     CGST: selectPo.cgst,
    //                     SGST: selectPo.sgst,
    //                     IGSTAmt: selectPo.igstAmt,
    //                     CGSTAmt: selectPo.cgstAmt,
    //                     SGSTAmt: selectPo.sgstAmt,
    //                     bale: [],
    //                     details: '',
    //                     bcolor: '',
    //                     poNo: selectPo?.poNo,
    //                     poId: selectPo?.ID
    //                 }));


    //             setTableRows(newData);

    //             const firstPo = selectPos[0];
    //             setFormData(prevFormData => ({
    //                 ...prevFormData,
    //                 tQtyM: firstPo.tot_mtr,
    //                 amt: firstPo.amt,
    //                 taxAmt: firstPo.taxAmt,
    //                 fAmt: firstPo.finalAmt,
    //                 vender: firstPo.partyNm,
    //                 partyId: firstPo.partyId,
    //                 firmId: firstPo.firmId
    //             }));
    //         } else {
    //             setTableRows([]);
    //         }
    //     }
    // }, [formData.PoId, polist.data]);

    const createLumpRow = (inwQty) => {

        if (lumpbar?.data?.Lumpbar) {
            setBarcodeLump({
                old: lumpbar.data.Lumpbar,
                new: lumpbar.data.Lumpbar
            });
        }

        const barcodeValue = lumpbar?.data?.Lumpbar || "";
        const parts = barcodeValue.split("-");

        let bar = "";
        let updateBarcode = "";

        if (parts.length >= 2) {
            const prefix = parts[0];
            const number = parseFloat(parts[1]) || 0;

            bar = `${prefix}-${number}`;
            updateBarcode = `${prefix}-${number + 1}`;
        }

        const newLump = {
            barcode: bar,
            mtr: inwQty,
            color: "",
            selected: false,
        };

        setBarcodeLump(prev => ({
            ...prev,
            new: updateBarcode
        }));

        const newRow = {
            id: (rows?.length || 0) + 1,
            bale: '',
            mtrKg: inwQty,
            rack: "",
            lumpRows: [newLump],
            selected: false,
            entry2: 0
        };

        return newRow;
    };

    const onlycretelumparray = (inwQty) => {
        if (lumpbar?.data?.Lumpbar) {
            setBarcodeLump({
                old: lumpbar.data.Lumpbar,
                new: lumpbar.data.Lumpbar
            });
        }

        const barcodeValue = lumpbar?.data?.Lumpbar || "";
        const parts = barcodeValue.split("-");

        let bar = "";
        let updateBarcode = "";

        if (parts.length >= 2) {
            const prefix = parts[0];
            const number = parseFloat(parts[1]) || 0;

            bar = `${prefix}-${number}`;
            updateBarcode = `${prefix}-${number + 1}`;
        }

        const newLump = {
            barcode: bar,
            mtr: inwQty,
            color: "",
            selected: false,
        };

        setBarcodeLump(prev => ({
            ...prev,
            new: updateBarcode
        }));

        return newLump;
    };

    const handlefetchData = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=polistbyID&poid=${id}`);
            // console.log(res.data);
            const firstPo = res.data?.data;
            const selectPos = res.data?.info;


            setFormData(prev => ({
                ...prev,
                tQtyM: firstPo.tot_mtr,
                amt: firstPo.amt,
                taxAmt: firstPo.taxAmt,
                fAmt: firstPo.finalAmt,
                vender: firstPo.partyNm,
                partyId: firstPo.partyId,
                firmId: firstPo.firmId,
                firmNm: firstPo?.firmNm,
                ordtype: firstPo?.ordtype,
                state_type: firstPo?.state_type
            }));



            const newData = selectPos
                .filter(selectPo => parseFloat(selectPo.balMtr) > 0) // only include balMtr > 0
                .map(selectPo => ({
                    netAmt: parseFloat(selectPo.Amount) + parseFloat(selectPo.igstAmt) + parseFloat(selectPo.cgstAmt) + parseFloat(selectPo.sgstAmt),
                    poInfoId: selectPo.poInfoId,
                    cloth: selectPo.cloth,
                    clothId: selectPo.clothId,
                    rate: selectPo.rate,
                    qty: selectPo.balMtr,
                    inwQty: selectPo.balMtr,
                    balQty: '0',
                    amount: selectPo.Amount,
                    IGST: selectPo.igst,
                    CGST: selectPo.cgst,
                    SGST: selectPo.sgst,
                    IGSTAmt: selectPo.igstAmt,
                    CGSTAmt: selectPo.cgstAmt,
                    SGSTAmt: selectPo.sgstAmt,
                    bale: [createLumpRow(selectPo.balMtr)],
                    baleNo: '',
                    details: '',
                    bcolor: '',
                    poNo: selectPo?.poNo,
                    poId: selectPo?.ID,
                    soId: selectPo?.soId,
                    sono: selectPo?.sono,
                    entry: 0
                }));


            setTableRows(newData);
        } catch (error) {
            console.log('error', error);
        }
    };


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));
        // if (dropdownType === "PoId") {
        //     // dispatch(fetchPOData(value));
        //     // console.log(value);
        //     handlefetchData(value);
        // }

        if (dropdownType === 'cloth' && value) {
            const selCloth = clothList?.data?.length > 0 ? clothList?.data?.find((item) => item.ID === value) : [];

            if (selCloth) {
                const { ID, clothName, uom, hsn, color, model, panna_size, shadeNo } = selCloth;
                handleAddRow(clothName, uom, hsn, ID, color, model, panna_size, shadeNo);
            }
            setTimeout(() => {
                setFormData({
                    ...formData,
                    cloth: ''
                });
            }, 1000);

        }

        if (dropdownType === 'soId' && value) {

            const data = await fetchClothDataSOno(value);

            if (data) {

                // setFormData(prev => ({
                //     ...prev,
                //     firm: data.firmId,
                //     vender: data.partyId,
                //     firmNm: data.firmNm,
                //     partyNm: data.partyNm
                // }));

                const clothKeys = ['mcloth', 'm1Id', 'm2Id', 'm3Id'];

                clothKeys.forEach((key) => {

                    const clothId = data[key];

                    // ✅ Skip if clothId is 0, null, undefined, empty
                    if (clothId && Number(clothId) !== 0) {

                        const mcloth = clothList?.data?.find(
                            item => Number(item.ID) === Number(clothId)
                        );


                        if (mcloth) {
                            const soId = data?.ID;
                            const sono = data?.sono;
                            const {
                                ID,
                                clothName,
                                uom,
                                hsn,
                                color,
                                model,
                                panna_size,
                                shadeNo

                            } = mcloth;

                            handleAddRow(
                                clothName,
                                uom,
                                hsn,
                                ID,
                                color,
                                model,
                                panna_size,
                                shadeNo,
                                soId,
                                sono,
                            );

                        }

                    }

                });

            }

        }
    };

    const handleAddRow = (clothNm, uom, hsn, value, soId, sono) => {
        const exists = tableRows.some(
            row => row.clothId === value && row.soId === soId
        );

        if (exists) {
            alert("This Cloth with the same SO already exists.");
            return;
        }
        const newRow = {
            clothId: value,
            cloth: clothNm,
            hsn: hsn,
            unit: uom,
            rate: '0',
            inwQty: '0',
            balQty: '0',
            amount: '0',
            bale: [createLumpRow(0)],
            baleNo: '',
            IGST: '5',
            IGSTAmt: '0',
            CGST: '2.5',
            CGSTAmt: '0',
            SGST: '2.5',
            SGSTAmt: '0',
            soId: soId,
            sono: sono,
            entry: 0,
            deliveryDate: ''
        };
        setTableRows([...tableRows, newRow]);
        setFormData(prev => ({
            ...prev,
            soId: ''
        }));
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };


    const handleRowInputChange = (index, e) => {
        const { name, value } = e.target;
        // const updatedRows = tableRows.map((row, i) => (i === index ? { ...row, [name]: value } : row));

        const updated = [...tableRows];
        updated[index] = {
            ...updated[index],
            [name]: name === 'baleNo' ? value.toUpperCase() : value
        };

        if (name === 'baleNo') {
            const baleArr = updated[index]?.bale;

            if (Array.isArray(baleArr) && baleArr.length < 2) {
                updated[index].bale = [
                    { ...baleArr[0], bale: value }
                ];
            }

        }

        if (name === 'IGST') {
            // console.log(value);
            const amount = parseFloat(updated[index]['amount']) || 0;
            const percentage = parseFloat(value);
            updated[index]['IGST'] = percentage;

            if (formData.state_type === '0') {
                const halfPer = percentage / 2;
                updated[index]['CGST'] = halfPer;
                updated[index]['SGST'] = halfPer;

                updated[index]['CGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                updated[index]['SGSTAmt'] = ((amount * halfPer) / 100).toFixed(2);
                updated[index]['IGSTAmt'] = '0';

                var cgst = updated.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst = updated.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = Math.round(cgst + sgst);


            } else {
                updated[index]['IGSTAmt'] = ((amount * percentage) / 100).toFixed(2);
                updated[index]['CGSTAmt'] = '0';
                updated[index]['SGSTAmt'] = '0';

                var totalTaxAmt = Math.round(updated.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0));
            }
            updated[index]['netAmt'] = totalTaxAmt;
            const update_amt = Math.round(updated.reduce((a, s) => a + Number(s.amount || 0), 0));
            const finalamt = Math.round(Number(update_amt) + Number(totalTaxAmt));
            setFormData(prev => ({
                ...prev,
                amt: update_amt,
                taxAmt: totalTaxAmt,
                fAmt: finalamt
            }));
        }

        if (name === 'bale') {
            const Id = updated[index].poInfoId; // Extract clothId from the updated row
            setNoOfBales(value);
            // setRows(Array.from({ length: value }, () => ({ bale: '', mtr: '0', location: '', Id: Id })));
            setTimeout(() => {
                handleAddButton();
            }, 1000);
        }

        if (name === 'rate') {
            const amt = Math.round(Number(updated[index]['inwQty']) * Number(value));
            updated[index]['amount'] = amt;

            if (formData.state_type === '0') {
                updated[index]['CGSTAmt'] = ((amt * parseFloat(updated[index]['CGST'])) / 100).toFixed(2);
                updated[index]['SGSTAmt'] = ((amt * parseFloat(updated[index]['SGST'])) / 100).toFixed(2);
                updated[index]['IGSTAmt'] = '0';
            } else {
                updated[index]['IGSTAmt'] = ((amt * parseFloat(updated[index]['IGST'])) / 100).toFixed(2);
                updated[index]['CGSTAmt'] = '0';
                updated[index]['SGSTAmt'] = '0';
            }

            const igstAmt = Math.round(updated.reduce((a, s) => a + Number(s.IGSTAmt || 0), 0));
            const cgstAmt = Math.round(updated.reduce((a, s) => a + Number(s.CGSTAmt || 0), 0));
            const sgstAmt = Math.round(updated.reduce((a, s) => a + Number(s.SGSTAmt || 0), 0));

            const taxAmt = igstAmt + cgstAmt + sgstAmt;
            const overall_amt = Math.round(updated.reduce((a, s) => a + Number(s.amount || 0), 0));
            const finalamt = taxAmt + overall_amt;

            setFormData(prev => ({
                ...prev,
                amt: overall_amt,
                taxAmt: taxAmt,
                fAmt: finalamt
            }));
        }

        if (name === 'inwQty') {

            const baleupdates = updated[index]?.bale || [];
            if (baleupdates.length > 0) {

                baleupdates[0] = {
                    ...baleupdates[0],
                    mtrKg: value
                };

                if (baleupdates[0]?.lumpRows?.length > 0) {
                    baleupdates[0].lumpRows[0] = {
                        ...baleupdates[0].lumpRows[0],
                        mtr: value
                    };
                } else {
                    const new_lump = onlycretelumparray(value);
                    baleupdates[0].lumpRows = [new_lump];
                }
            } else {
                const new_bale = createLumpRow(value);
                updated[index].bale = [new_bale];
            }
            updated[index]['amount'] = Number(updated[index]['rate']) * parseFloat(value);
            if (formData.state_type === '0') {
                updated[index]['CGSTAmt'] = ((Number(updated[index]['amount']) * parseFloat(updated[index]['CGST'])) / 100).toFixed(2);
                updated[index]['SGSTAmt'] = ((Number(updated[index]['amount']) * parseFloat(updated[index]['SGST'])) / 100).toFixed(2);
                updated[index]['IGSTAmt'] = '0';

                var cgst = updated.reduce((total, row) => total + parseFloat(row.CGSTAmt || 0), 0);
                var sgst = updated.reduce((total, row) => total + parseFloat(row.SGSTAmt || 0), 0);
                var totalTaxAmt = Math.round(cgst + sgst);
            } else {
                updated[index]['IGSTAmt'] = ((Number(updated[index]['amount']) * parseFloat(updated[index]['IGST'])) / 100).toFixed(2);
                updated[index]['CGSTAmt'] = '0';
                updated[index]['SGSTAmt'] = '0';

                var totalTaxAmt = Math.round(updated.reduce((total, row) => total + parseFloat(row.IGSTAmt || 0), 0));
            }
            const totmtr = (updated.reduce((a, s) => a + parseFloat(s.inwQty || 0), 0)).toFixed(2);

            updated[index]['netAmt'] = totalTaxAmt;
            const update_amt = Math.round(updated.reduce((a, s) => a + Number(s.amount || 0), 0));
            const finalamt = Math.round(Number(update_amt) + Number(totalTaxAmt));
            setFormData(prev => ({
                ...prev,
                amt: update_amt,
                taxAmt: totalTaxAmt,
                fAmt: finalamt,
                tQtyM: totmtr
            }));
        }
        // console.log(updated);
        setTableRows(updated);
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.length === 1 && prevSelectedRows[0] === index) {
                // If the checkbox to be deselected is the only selected one, deselect it
                return [];
            } else {
                // Deselect all other checkboxes and select the current one
                return [index];
            }
        });
    };


    // const handleCheckboxChange = (index) => {
    //     setSelectedRows(prevSelectedRows => {
    //         if (prevSelectedRows.includes(index)) {
    //             const prev = prevSelectedRows.filter(rowIndex => rowIndex !== index);
    //             return prev;

    //         } else {

    //             // const selectedRow = tableRows[index];

    //             // let rate = parseFloat(selectedRow.rate) || 0;
    //             // let qty = parseFloat(selectedRow.qty) || 0;
    //             // let amnt = (rate * qty).toFixed(2);
    //             // if (selectedRow.IGSTAmt !== '0') {
    //             //     var taxAmnt = selectedRow.IGSTAmt;
    //             //     var finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
    //             // } else {
    //             //     taxAmnt = parseFloat(selectedRow.CGSTAmt) + parseFloat(selectedRow.SGSTAmt);
    //             //     finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
    //             // }

    //             // setFormData({
    //             //     ...formData,
    //             //     tQtyM: qty,
    //             //     amt: amnt,
    //             //     taxAmt: taxAmnt,
    //             //     fAmt: finalAmnt,
    //             // });

    //             return [...prevSelectedRows, index];
    //         }
    //     });
    // };


    const handleAddButton = () => {
        setOpenBale(true);
    };

    const handleInputChanged = (index, field, value) => {
        if (field === 'mtr') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index][field] = value;
            return newRows;
        });
    };

    const handleBaleSubmit = () => {
        const newData = rows.map((item) => (`${item.Id}||${item.bale}||${item.mtr}||${item.location}`));
        const inw_qty = [...rows.map((item) => parseFloat(item.mtr))] || [];
        const sum_inwQty = (inw_qty.reduce((sum, qty) => sum + qty, 0)).toFixed(2);

        const updatedRows = tableRows.map((ele, index) => {

            if (selectedRows.includes(index)) {
                const amnt = (parseFloat(ele.rate) * sum_inwQty).toFixed(2);
                if (ele.IGSTAmt !== '0') {
                    var igstAmt = ((parseFloat(ele.IGST) * amnt) / 100).toFixed(2) || 0;
                    var net_amt = parseFloat(amnt) + parseFloat(igstAmt);
                } else {
                    var cgstAmt = ((parseFloat(ele.CGST) * amnt) / 100).toFixed(2) || 0;
                    var sgstAmt = ((parseFloat(ele.SGST) * amnt) / 100).toFixed(2) || 0;
                    net_amt = parseFloat(amnt) + parseFloat(cgstAmt) + parseFloat(sgstAmt);
                }
                return {
                    ...ele,
                    details: newData,
                    netAmt: net_amt,
                    inwQty: sum_inwQty,
                    amount: amnt,
                    IGSTAmt: igstAmt || 0,
                    CGSTAmt: cgstAmt || 0,
                    SGSTAmt: sgstAmt || 0,
                };
            }
            return ele;
        });

        setTableRows(updatedRows);
        setOpenBale(false);
        const update_qty = [...updatedRows.map((val) => parseFloat(val.inwQty))] || [];
        const sum_updateQty = (update_qty.reduce((sum, qty) => sum + qty, 0)).toFixed(2);
        const updated_amt = [...updatedRows.map((val) => parseFloat(val.amount))] || [];
        const sum_updateAmt = (updated_amt.reduce((sum, amt) => sum + amt, 0)).toFixed(2);
        const update_igstAmt = [...updatedRows.map((val) => parseFloat(val.IGSTAmt))] || [];
        const sum_igstAmt = update_igstAmt.reduce((sum, igst) => sum + igst, 0);
        const update_cgstAmt = [...updatedRows.map((val) => parseFloat(val.CGSTAmt))] || [];
        const sum_cgstAmt = update_cgstAmt.reduce((sum, cgst) => sum + cgst, 0);
        const update_sgstAmt = [...updatedRows.map((val) => parseFloat(val.SGSTAmt))] || [];
        const sum_sgstAmt = update_sgstAmt.reduce((sum, sgst) => sum + sgst, 0);
        if (sum_igstAmt !== 0) {
            var taxAmt = (sum_igstAmt).toFixed(2);
        } else {
            taxAmt = (sum_cgstAmt + sum_sgstAmt).toFixed(2);
        }

        const final_amt = (parseFloat(sum_updateAmt) + parseFloat(taxAmt)).toFixed(2);
        setFormData(prevFormData => ({
            ...prevFormData,
            tQtyM: sum_updateQty,
            amt: sum_updateAmt,
            taxAmt: taxAmt,
            fAmt: final_amt
        }));

    };

    const handleBaleClick = (index, clothId, inwQty) => {
        setCurrentIndex(index);
        // Construct the URL with query parameters or use a placeholder route
        const id = index + 1;

        const url = `/BaleLumpEntry/${id}-${clothId}-${inwQty}`;
        // console.log(tableRows);
        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');

        // // Set up a listener to receive data from the child
        // window.addEventListener('message', (event) => {
        //     // Ensure the event comes from the expected source
        //     if (event.origin !== window.location.origin) return;

        //     // Process the data received from the child
        //     // console.log('Data received from child:', event.data);
        //     const updateTable = [...tableRows];
        //     updateTable[index].bale = event.data;
        //     setTableRows(updateTable);
        //     // Update the parent state or perform any required action with the received data
        // });
    };

    const handleBaleClick2 = (index, clothId, inwQty, bale, baleNo) => {
        // console.log(baleNo);
        setCurrentIndex(index);
        setOpenBaleBox(true);
        // window.open(url, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
        setTotalMtr(inwQty);

        var currentClothNm = tableRows?.find(i => i.clothId === clothId)?.cloth;
        // console.log(currentClothNm);

        setFormData(prev => ({
            ...prev,
            currentClothNm: currentClothNm
        }));


        if (bale.length > 0) {
            const baleList = (baleNo || "").split(",").map(b => b.trim()).filter(Boolean);;

            const update_bale = [...bale];
            if (baleList.length === 1) {
                update_bale[0].bale = baleNo;
                update_bale[0].mtrKg = inwQty;
            }

            setBaleRows(update_bale);
        } else {
            if (lumpbar?.data?.Lumpbar) {
                setBarcodeLump({
                    old: lumpbar.data.Lumpbar,
                    new: lumpbar.data.Lumpbar
                });
            }
            if (inwQty > 0) {

                const barcodeValue = lumpbar?.data?.Lumpbar || "";
                const parts = barcodeValue.split("-");

                let bar = "";
                let updateBarcode = "";

                if (parts.length >= 2) {
                    const prefix = parts[0];
                    const number = parseFloat(parts[1]) || 0;

                    bar = `${prefix}-${number}`;
                    updateBarcode = `${prefix}-${number + 1}`;
                }

                const newLump = {
                    barcode: bar,
                    mtr: inwQty,
                    color: "",
                    selected: false,
                };

                setBarcodeLump(prev => ({
                    ...prev,
                    new: updateBarcode
                }));

                const newRow = {
                    id: (rows?.length || 0) + 1,
                    bale: baleNo,
                    mtrKg: inwQty,
                    rack: "",
                    lumpRows: [newLump],
                    selected: false,
                    entry2: 1
                };

                setBaleRows([newRow]);
            }
        }

    };
    console.log(tableRows)

    // const handleMessage = (event) => {
    //     // Ensure the message is from the same origin
    //     if (event.origin !== window.location.origin) return;

    //     const receivedData = event.data; // Data sent by the child
    //     // console.log("Data received from child:", receivedData);

    //     // Ensure currentIndex and tableRows are valid
    //     if (typeof currentIndex !== "number" || currentIndex < 0 || !tableRows[currentIndex]) {
    //         console.error("Invalid index or tableRows");
    //         return;
    //     }

    //     // Update the table row with the new data
    //     setTableRows((prevTableRows) => {
    //         const updatedTable = [...prevTableRows];
    //         updatedTable[currentIndex].bale = receivedData;
    //         return updatedTable;
    //     });
    // };


    function convertIntoOneObject(array, formData) {
        const mulDetails = [...array.map((item) => item.details)] || [];
        const Qty = [...array.map((item) => parseFloat(item.inwQty))] || [];
        const sum_qty = Qty.reduce((sum, qty) => sum + qty, 0);
        const Amt = [...array.map((item) => parseFloat(item.amount))] || [];
        const sum_amt = Amt.reduce((sum, amt) => sum + amt, 0);
        const igstAmt = [...array.map((item) => parseFloat(item.IGSTAmt))] || [];
        const cgstAmt = [...array.map((item) => parseFloat(item.CGSTAmt))] || [];
        const sgstAmt = [...array.map((item) => parseFloat(item.SGSTAmt))] || [];
        const sum_igstAmt = igstAmt.reduce((sum, igst) => sum + igst, 0);
        const sum_cgstAmt = cgstAmt.reduce((sum, cgst) => sum + cgst, 0);
        const sum_sgstAmt = sgstAmt.reduce((sum, sgst) => sum + sgst, 0);
        const tax_Amt = parseFloat(sum_igstAmt) + parseFloat(sum_cgstAmt) + parseFloat(sum_sgstAmt);
        const final_Amt = sum_amt + tax_Amt;

        const tableData = {
            poInfoId: [...array.map((item) => item.poInfoId)],
            netAmt: [...array.map((item) => item.netAmt)],
            clothNm: [...array.map((item) => item.cloth)],
            clothId: [...array.map((item) => item.clothId)],
            rate: [...array.map((item) => item.rate)],
            qty: [...array.map((item) => item.qty)],
            inwQty: [...array.map((item) => item.inwQty)],
            balQty: [...array.map((item) => item.balQty)],
            amount: [...array.map((item) => item.amount)],
            IGST: [...array.map((item) => item.IGST)],
            CGST: [...array.map((item) => item.CGST)],
            SGST: [...array.map((item) => item.SGST)],
            IGSTAmt: [...array.map((item) => item.IGSTAmt)],
            CGSTAmt: [...array.map((item) => item.CGSTAmt)],
            SGSTAmt: [...array.map((item) => item.SGSTAmt)],
            // bcolor: [...array.map((item) => item.bcolor)],

            details: mulDetails.reduce((acc, curr) => acc.concat(curr), []),

            // Include formData fields

            vender: formData.vender,
            partyId: formData.partyId,
            PoId: formData.PoId,
            dt: formData.dt,
            tQtyM: sum_qty,
            PiNo: formData.PiNo,
            firmId: formData.firmId,
            amt: sum_amt,
            taxAmt: tax_Amt,
            fAmt: final_Amt,
            lrdt: formData.lrdt,
            lrno: formData.lrno,
            transpt: formData.transpt,
            bill: formData.bill,
            locId: formData.locId,
            userId: formData.userId
        };
        return tableData;
    };

    const postObj = (tableRows, formData) => {

        // 🔎 Validate tableRows
        if (!tableRows || tableRows.length === 0) {
            alert("Table rows cannot be empty");
            return null;
        }

        for (let i = 0; i < tableRows.length; i++) {

            const row = tableRows[i];

            if (!row.bale || (Array.isArray(row.bale) && row.bale.length === 0) || (typeof row.bale === "string" && row.bale.trim() === "")) {
                alert(`Please enter Bale value for row ${i + 1}`);
                return null;
            }

            if (!row.rate || Number(row.rate) <= 0) {
                alert(`Please enter valid Rate for row ${i + 1}`);
                return null;
            }

            if (!row.inwQty || Number(row.inwQty) <= 0) {
                alert(`Please enter valid Quantity for row ${i + 1}`);
                return null;
            }

            if (!row.amount || Number(row.amount) <= 0) {
                alert(`Amount missing in row ${i + 1}`);
                return null;
            }
        }

        // 🔎 Validate formData fields
        const requiredFields = [
            "vender",
            // "partyId",
            // "PoId",
            "dt",
            "tQtyM",
            "PiNo",
            "firm",
            "amt",
            "taxAmt",
            "fAmt",
            "lrdt",
            "lrno",
            "transpt",
            "bill",
            "locId",
            "userId",
            "ordtype"
        ];

        for (let field of requiredFields) {
            if (
                formData[field] === undefined ||
                formData[field] === null ||
                formData[field] === ""
            ) {
                alert(`Please enter ${field}`);
                return null;
            }
        }

        // ✅ If all validations passed
        const data = {
            tableRows: tableRows,
            partyId: formData.vender,
            PoId: 0,
            dt: formData.dt,
            tQtyM: formData.tQtyM,
            PiNo: formData.PiNo,
            firmId: formData.firm,
            amt: formData.amt,
            taxAmt: formData.taxAmt,
            fAmt: formData.fAmt,
            lrdt: formData.lrdt,
            lrno: formData.lrno,
            transpt: formData.transpt,
            bill: formData.bill,
            locId: formData.locId,
            ordtype: formData.ordtype,
            userId: formData.userId,
            entry_type: 'DirectPI'
        };

        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // const finalObject = convertIntoOneObject(tableRows, formData);
            // console.log(finalObject)

            // const result = await dispatch(createPurInwEntry(finalObject)).unwrap();
            // console.log('POST request successful!', result);
            // // toast.success("Purchase Inward Added");
            // alert("Purchase Inward Added");
            // window.location.reload();

            const postobj = postObj(tableRows, formData);
            // console.log(postobj);

            const result = await axios.post(`${baseUrl}?apicall=insertPurchaseInwardClothEntry`, postobj);
            const data = result?.data;
            if (data.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                alert(msg);
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {
            const index = resendData?.index;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableRows];

            let qty = updateTableData[index].qty;
            let inwQty = updateTableData[index].inwQty;
            let balQty = updateTableData[index].balQty;
            let rate = updateTableData[index].rate;

            inwQty = parseFloat(totmtr);
            balQty = parseFloat(qty) - parseFloat(totmtr);
            const amount = parseFloat(totmtr) * parseFloat(rate);

            updateTableData[index].inwQty = inwQty;
            updateTableData[index].balQty = balQty;
            updateTableData[index].amount = amount;

            const tQtyM = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.inwQty), 0);
            const amt = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.amount), 0);
            const famt = amt + parseFloat(formData.taxAmt);

            setTableRows(updateTableData);
            setFormData(prevFormData => ({
                ...prevFormData,
                tQtyM: tQtyM,
                amt: amt,
                fAmt: famt
            }));
        }
        // Process the data (e.g., update state)
    };

    window.handleResendFromChild = handleResend;

    const dropdownlistfirst = [
        {
            label: 'PO No.',
            id: 'PoId',
            options: onlyPonos?.data?.length > 0 ? onlyPonos?.data : [],
            value: formData.PoId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'PoId', value: newValue ? newValue.ID : '' } }, 'PoId'),
            getOptionLabel: (option) => option.poNo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value.ID) || null;
                }
                return null;
            },
        }

    ];


    const dropdownlistsecond = [
        {
            label: 'Transport',
            id: 'transpt',
            options: transptList?.data || [],
            value: formData.transpt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'transpt', value: newValue ? newValue.transportNm : '' } }, 'transpt'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.transportNm === value.transportNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.transportNm === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }

    ];


    // const handleAddRow = () => {
    //     const no_bar = barcodeLump?.new?.split('-');
    //     var bar = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1])}` : 0;
    //     const updateBarcode = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}` : 0;
    //     const newLump = {
    //         barcode: bar,
    //         mtr: '',
    //         color: '',
    //         selected: false,
    //     };

    //     const newRow = {
    //         id: rows.length + 1,
    //         bale: "",
    //         mtrKg: "",
    //         rack: "",
    //         lumpRows: [newLump],
    //         selected: false,
    //         entry2: 0
    //     };
    //     setBaleRows(prev => [...prev, newRow]);
    //     setBarcodeLump(prev => ({
    //         ...prev,
    //         new: updateBarcode
    //     }));
    // };

    const handleDeleteRows = () => {
        const filteredRows = baleRows.filter((row) => !row.selected);
        const totmtr = filteredRows?.reduce((acc, sum) => acc + parseFloat(sum.mtrKg || 0), 0);
        setTotalMtr(totmtr);
        setBaleRows(filteredRows);
    };

    const handleRowSelection = (index) => {
        const newRows = [...baleRows];
        newRows[index].selected = !newRows[index].selected;
        const currmtr = newRows[index].mtrKg;
        let totmtr = newRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtrKg), 0);
        let finaltot = totmtr - parseFloat(currmtr);
        // setTotalMtr(finaltot);
        setBaleRows(newRows);
    };


    const handleInputChange2 = (index, field, value) => {
        let newRows = [...baleRows];
        if (field === "bale") {
            value = value.toUpperCase();
        }

        newRows[index][field] = value;

        if (field === 'bale') {
            const check_bale = newRows?.find((item) => item.bale === value)?.id;
            // console.log(check_bale)
        }
        // Update total if the field is "mtrKg"
        if (field === "mtrKg") {


            //
            // ✅ Ensure lump array exists
            if (!newRows[index].lump) {
                newRows[index].lump = [];
            }

            // ✅ Ensure first object exists
            if (!newRows[index].lump[0]) {
                newRows[index].lump[0] = { mtr: 0 };
            }

            // ✅ Set default value
            newRows[index].lump[0].mtr = value;
            newRows[index].lumpRows[0].mtr = value;
            // console.log(newRows[index])

            const total = newRows?.reduce((sum, row) => sum + parseFloat(row.mtrKg || 0), 0);
            // if (parseFloat(formData.totmtr) > total) {
            //     setTotalMtr(total.toFixed(2));
            // } else {
            //     alert(`Total Mtr Up to : ${formData.totmtr}`);
            // }
            setTotalMtr(total.toFixed(2));


            setLumpTotMtr(value);
        }
        // Handle "lump" field change
        // if (field === "lump") {
        //     const lumpCount = parseInt(value, 10) || 0; // Ensure value is an integer
        //     const barcode = lumpbar?.data?.Lumpbar;
        //     const no_bar = barcode?.split('-');

        //     const updatedLumpRows = Array.from({ length: lumpCount }, (_, idx) => (
        //         {
        //             barcode: no_bar ? `${no_bar[0]} - ${parseFloat(no_bar[1]) + idx}` : "", // If barcode exists, append the index for uniqueness
        //             mtr: "" // Initialize the mtr as empty
        //         }));

        //     newRows[index].lumpRows = updatedLumpRows;
        // }
        setBaleRows(newRows);
    };


    const handleAddlump = (index, bale) => {
        // Set necessary states
        setLumpDetails(true);
        setLumpId(index); // Update lumpId state
        setBaleLump(bale); // Update baleLump state

        // Access rows directly using the index passed to the function
        const row = baleRows[index];
        // console.log(row);
        if (row?.lumpRows?.length > 0) {
            setOpenEdit((prevState) => !prevState); // Use functional update for toggling state
            const lumprows = row.lumpRows; // Directly access lumpRows from the current index
            const updateLumps = [...lumprows];
            // console.log(updateLumps);
            const no_bar = barcodeLump?.new.split('-');
            var bar = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1])}` : 0;
            const updateBarcode = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}` : 0;

            const newLump = {
                barcode: bar,
                mtr: '',
                color: '',
                selected: false,
            };

            // Update other states
            setLumpRows(updateLumps);
            setBaleLump(row.bale);
            setLumpTotMtr(row.mtrKg);
        }
    };

    const parseBarcode = (b) => {
        if (!b) return null;
        const s = String(b);
        const i = s.lastIndexOf("-");
        if (i === -1) return null;

        const prefix = s.slice(0, i);
        const num = Number(s.slice(i + 1));
        if (!prefix || Number.isNaN(num)) return null;

        return { prefix, num };
    };


    const handleDeleteLumps = () => {
        const filteredRows = lumpRows.filter((row) => !row.selected);
        setLumpRows(filteredRows);

        // total mtr (safe)
        const totmtr = filteredRows.reduce((acc, r) => acc + (parseFloat(r.mtr) || 0), 0);
        setLumpTotMtr(totmtr);

        // barcode update: next = max(remaining)+1, if none => old
        const base = barcodeLump?.old || barcodeLump?.new;
        const baseParts = parseBarcode(base);
        if (!baseParts) return;

        if (filteredRows.length === 0) {
            setBarcodeLump((prev) => ({ ...prev, new: barcodeLump?.old }));
            return;
        }

        let maxNum = -Infinity;
        for (const r of filteredRows) {
            const p = parseBarcode(r.barcode);
            if (p && p.prefix === baseParts.prefix) {
                maxNum = Math.max(maxNum, p.num);
            }
        }

        // if no valid barcode found in rows, fallback to base number - 1
        if (!Number.isFinite(maxNum)) maxNum = baseParts.num - 1;

        const nextBarcode = `${baseParts.prefix}-${maxNum + 1}`;
        setBarcodeLump((prev) => ({ ...prev, new: nextBarcode }));
    };


    const handleLumpAddBale = () => {
        const newRow = [...baleRows];
        newRow[lumpId].lumpRows = lumpRows;
        // newRow[lumpId].mtrKg = lumpTotMtr;
        newRow[lumpId].mtrKg = lumpRows.reduce((acc, sum) => acc + Number(sum.mtr || 0), 0);
        newRow[lumpId].entry2 = 1;
        const updatebar = barcodeLump?.new;

        // const updateTotalBalemtr = lumpTotMtr + totalMtr;
        const updateTotalBalemtr = newRow.reduce((sum, entry) => sum + (parseFloat(entry.mtrKg) || 0), 0);
        setBaleRows(newRow);
        setLumpRows([]);
        setLumpTotMtr(0);

        setBarcodeLump(prev => ({
            ...prev,
            old: updatebar
        }));
        setBaleLump('');
        setTotalMtr(updateTotalBalemtr);
        setLumpDetails(false);
    };

    const handleLumpMtr = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].mtr = value;
        // Calculate the sum of all mtr values in the lumpRows array
        const totalMtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.mtr) || 0;
            return sum + mtrValue;
        }, 0);

        setLumpTotMtr(totalMtr);
        setLumpRows(updateLumps);
    };


    const handleLumpSelection = (index) => {
        const newRows = [...lumpRows];
        newRows[index].selected = !newRows[index].selected;
        setLumpRows(newRows);
    };

    const handlePerticularLumpAdd = () => {
        // initialize from rows only if local state is empty
        const baseList =
            (lumpRows?.length ? lumpRows : (baleRows?.[lumpId]?.lumpRows ?? []));

        const baseBarcode =
            (baseList.length > 0 ? barcodeLump?.new : barcodeLump?.old) ?? barcodeLump?.new;

        if (!baseBarcode) return;

        const [prefix, numStr] = baseBarcode.split("-");
        const num = Number(numStr);

        const bar = `${prefix}-${num}`;
        const nextBarcode = `${prefix}-${num + 1}`;

        const newLump = {
            barcode: bar,
            mtr: "",
            color: "",
            selected: false,
        };

        setBaleLump(baleRows?.[lumpId]?.bale);
        setLumpTotMtr(baleRows?.[lumpId]?.mtrKg);

        setLumpRows(prev => {
            const start = (prev?.length ? prev : (baleRows?.[lumpId]?.lumpRows ?? []));
            return [...start, newLump];
        });

        setBarcodeLump(prev => ({ ...prev, new: nextBarcode }));
    };

    const handleClose = () => {
        setLumpDetails(false);
    };


    const handleLumpColor = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].color = value.toUpperCase();
        setLumpRows(updateLumps);
    };
    // console.log(tableRows)
    const handleBaleAdd2 = () => {
        const rowsdata = [...baleRows];
        const updatedTableRows = [...tableRows];
        const rate = Number(updatedTableRows[currentIndex]?.rate || 0);
        const baleNos = rowsdata?.map(i => i.bale).join(",");

        const inwQty = Number(totalMtr || 0);
        const amt = Math.round(rate * inwQty);
        let igstAmt2 = 0;
        let cgstAmt2 = 0;
        let sgstAmt2 = 0;
        if (formData.state_type === '1') {
            const igst = Number(updatedTableRows[currentIndex]?.IGST || 0);
            igstAmt2 = Number(((amt * igst) / 100).toFixed(2));
        } else {
            const cgst = Number(updatedTableRows[currentIndex]?.CGST || 0);
            const sgst = Number(updatedTableRows[currentIndex]?.SGST || 0);

            cgstAmt2 = Number(((amt * cgst) / 100).toFixed(2));
            sgstAmt2 = Number(((amt * sgst) / 100).toFixed(2));
        }
        updatedTableRows[currentIndex] = {
            ...updatedTableRows[currentIndex],
            bale: rowsdata,
            inwQty: totalMtr,
            amount: amt,
            IGSTAmt: igstAmt2,
            CGSTAmt: cgstAmt2,
            SGSTAmt: sgstAmt2,
            entry: 1,
            baleNo: baleNos
        };
        console.log(updatedTableRows)

        const igstamt = updatedTableRows.reduce((a, s) => a + Number(s.IGSTAmt || 0), 0);
        const cgstamt = updatedTableRows.reduce((a, s) => a + Number(s.CGSTAmt || 0), 0);
        const sgstamt = updatedTableRows.reduce((a, s) => a + Number(s.SGSTAmt || 0), 0);

        const taxAmt = Math.round(igstamt + cgstamt + sgstamt);
        const overall_amt = Math.round(updatedTableRows.reduce((a, s) => a + Number(s.amount || 0), 0));
        const finalamt = Math.round(taxAmt + overall_amt);
        const totmtr = (updatedTableRows.reduce((a, s) => a + parseFloat(s.inwQty || 0), 0)).toFixed(2);
        // update state
        setTableRows(updatedTableRows);
        setCurrentIndex(-1);
        setBaleRows([]);
        setFormData(prev => ({
            ...prev,
            currentClothNm: '',
            amt: overall_amt,
            taxAmt: taxAmt,
            fAmt: finalamt,
            tQtyM: totmtr
        }));
        setTotalMtr(0);
        setOpenBaleBox(false);
    };

    const handleRemoveSelectedRows = () => {
        const updatedRows = tableRows?.filter((_, index) => !selectedRows.includes(index));

        const igstamt = updatedRows?.reduce((a, c) => a + parseFloat(c.IGSTAmt || 0), 0);
        const sgstamt = updatedRows?.reduce((a, c) => a + parseFloat(c.SGSTAmt || 0), 0);
        const cgstamt = updatedRows?.reduce((a, c) => a + parseFloat(c.CGSTAmt || 0), 0);

        const taxamt = Math.round(igstamt + sgstamt + cgstamt);

        const amt = Math.round(updatedRows?.reduce((a, c) => a + parseFloat(c.amount || 0), 0));

        const finalamt = taxamt + amt;
        const totmtr = (updatedRows?.reduce((a, c) => a + parseFloat(c.inwQty || 0), 0));

        setTableRows(updatedRows);
        setSelectedRows([]); // clear selection after delete
        setFormData(prev => ({
            ...prev,
            taxAmt: taxamt,
            amt: amt,
            fAmt: finalamt,
            tQtyM: totmtr
        }))

    };


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleNavigateCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const orderOptions = [
        { label: 'Manual', value: 'Manual' },
        { label: 'Sale Order', value: 'Sale Order' }
    ];


    const dropdownlistfirstCloth = [
        {
            label: 'Cloth',
            id: 'cloth',
            options: clothList?.data || [],
            value: formData.cloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cloth', value: newValue ? newValue.ID : '' } }, 'cloth'),
            getOptionLabel: (option) => `${option.clothName}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateCloth(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('cloth'),
            handleDropdownClose: () => handleDropdownClose('cloth'),
        }
    ];

    const dropdownparty = [

        {
            label: 'Purchase Party',
            id: 'vender',
            options: partyList?.data || [],
            value: formData.vender,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'vender', value: newValue ? newValue.ID : '' } }, 'vender'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('vender'),
            handleDropdownClose: () => handleDropdownClose('vender'),
        }
    ];

    const handleRadioChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
            fAmt: '0',
            firm: '',
            taxAmt: '0',
            tQtyM: '0',
            amt: '0',
            vender: '',
            shftTo: '',
            ref: ''
        }));
        setTableRows([]);
    };

    const dropdownlistsecondfirm = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmList?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownsolist = [
        {
            label: 'Sale Order',
            id: 'soId',
            options: solist || [],
            value: formData.soId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleAddRowBale = () => {
        const no_bar = barcodeLump?.new?.split('-');
        var bar = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1])}` : 0;
        const updateBarcode = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}` : 0;
        const newLump = {
            barcode: bar,
            mtr: '',
            color: '',
            selected: false,
        };

        const newRow = {
            id: rows.length + 1,
            bale: "",
            mtrKg: "",
            rack: "",
            lumpRows: [newLump],
            selected: false,
            entry2: 0
        };
        setBaleRows(prev => [...prev, newRow]);
        setBarcodeLump(prev => ({
            ...prev,
            new: updateBarcode
        }));
    };

    // console.log(onlyPonos?.data)
    return (
        <>
            <Titlebar data={InwardMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Direct Purchase Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'PI No', name: 'PiNo', type: 'readOnly' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={(e) => handleDateChange(e)}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={(e) => handleInputChange(e)}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <RadioComponent
                                    label='Order Type'
                                    name='ordtype'
                                    value={formData.ordtype}
                                    options={orderOptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />


                                {
                                    formData.ordtype === "Sale Order" && dropdownsolist && dropdownsolist.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownlistsecondfirm && dropdownlistsecondfirm.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownparty && dropdownparty.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }



                                {[
                                    { label: 'Total Mtr/KG', name: 'tQtyM', type: 'readOnly' },
                                    { label: 'Amount', name: 'amt', type: 'readOnly' },
                                    { label: 'GST Amount', name: 'taxAmt', type: 'readOnly' },
                                    { label: 'Total Amount', name: 'fAmt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={(e) => handleDateChange(e)}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={(e) => handleInputChange(e)}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'LR No', name: 'lrno' },
                                    { label: 'LR Date', name: 'lrdt', type: 'date' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={(e) => handleDateChange(e)}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={(e) => handleInputChange(e)}
                                                            inputProps={{ style: styled.input, readOnly: field.name == 'PoNo' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'Bill/Challan No', name: 'bill' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={(e) => handleInputChange(e)}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    formData.ordtype === "Manual" && dropdownlistfirstCloth && dropdownlistfirstCloth.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {selectedRows.length > 0 &&
                                    <Grid item xs={12} textAlign='center'>
                                        <button type="button" className="lump-btn" onClick={() => handleRemoveSelectedRows()}>Remove</button>
                                    </Grid>}

                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        {formData.ordtype === "Sale Order" && <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SO No.</TableCell>}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Mtr./KG</TableCell> */}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Inward Mtr./KG</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bal Mtr./KG</TableCell> */}
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bale No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGST</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGST</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGST</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Details</TableCell> */}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows?.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {index + 1}
                                                            </TableCell>

                                                            {
                                                                formData.ordtype === "Sale Order" &&
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    {row.sono}
                                                                </TableCell>
                                                            }
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {row.cloth}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <input
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '100px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            {/* 
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                />
                                                                <input
                                                                    type='text'
                                                                    name="bcolor"
                                                                    value={row.bcolor}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '100px', padding: '2px', outline: 'none' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell> */}
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                <input
                                                                    type='text'
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                <input
                                                                    type='text'
                                                                    name="qty"
                                                                    value={row.qty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '80px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell> */}
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {row.entry === 0 ?
                                                                    <input
                                                                        type='text'
                                                                        name="inwQty"
                                                                        value={row.inwQty}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '80px', padding: '1px' }}
                                                                        readOnly={!selectedRows.includes(index)}
                                                                    // readOnly
                                                                    /> :
                                                                    row.inwQty
                                                                }
                                                            </TableCell>

                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {row.entry === 0 ?
                                                                    <input
                                                                        type='text'
                                                                        name="baleNo"
                                                                        value={row.baleNo}
                                                                        onChange={(e) => handleRowInputChange(index, e)}
                                                                        style={{ width: '80px', padding: '1px' }}
                                                                        readOnly={!selectedRows.includes(index)}
                                                                    />
                                                                    : row.baleNo
                                                                }
                                                            </TableCell>
                                                            {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                               
                                                                <input
                                                                    type='text'
                                                                    name="balQty"
                                                                    value={row.balQty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell> */}
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                {/* <input
                                                                    type='text'
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                {row.amount}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <input
                                                                    type='text'
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                <select name="IGST" value={row.IGST} onChange={(e) => handleRowInputChange(index, e)}>
                                                                    <option value="5">5</option>
                                                                    <option value="12">12</option>
                                                                    <option value="18">18</option>
                                                                </select>
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <input
                                                                    type='text'
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                {row.IGSTAmt}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <input
                                                                    type='text'
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                {row.CGST}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <input
                                                                    type='text'
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                {row.CGSTAmt}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <input
                                                                    type='text'
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                {row.SGST}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                {/* <input
                                                                    type='text'
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                /> */}
                                                                {row.SGSTAmt}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>

                                                                <Button variant="contained" color="primary" size='small'
                                                                    // onClick={() => handleBaleClick(index, row.clothId, row.inwQty)}
                                                                    onClick={() => handleBaleClick2(index, row.clothId, row.inwQty, row.bale, row.baleNo)}
                                                                    disabled={!selectedRows.includes(index)}
                                                                >
                                                                    Add
                                                                </Button>
                                                            </TableCell>
                                                            {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                <TextareaAutosize
                                                                    name="details"
                                                                    value={row.details}
                                                                    inputProps={{ style: styled.txtArea, readOnly: true }}
                                                                    style={{ padding: '6px' }}
                                                                />
                                                            </TableCell> */}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>



                                {openBaleBox &&
                                    <div className="bale-details-container" style={{ border: '1px solid black', width: '100%' }}>
                                        {/* <div style={{ border: "1px solid black", position: "relative" }}>
                                            <MdClose
                                                onClick={() => setOpenBaleBox(false)}
                                                style={{
                                                    position: "absolute",
                                                    top: "10px",
                                                    right: "10px",
                                                    fontSize: "26px",
                                                    color: "red",
                                                    cursor: "pointer",
                                                    zIndex: 999
                                                }}
                                            />
                                        </div> */}
                                        <h3>Bale Details <FaArrowRightLong className="right-arrow" /></h3>

                                        <div className="button-group">
                                            <button className="add" onClick={() => handleAddRowBale()}>Add</button>
                                            <button className="delete" onClick={() => handleDeleteRows()}>Delete</button>
                                        </div>
                                        <div className="total-meter">
                                            Cloth: <span>{formData.currentClothNm}</span>
                                        </div>

                                        <div className="total-meter">
                                            Total Mtr: <span>{totalMtr}</span>
                                        </div>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Bale</th>
                                                    <th>Bale Mtr</th>
                                                    <th>Rack</th>
                                                    <th>Lump</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {baleRows?.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={row.selected}
                                                                onChange={() => handleRowSelection(index)}
                                                            />{" "}
                                                            {index + 1}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter Bale No"
                                                                value={row.bale}
                                                                onChange={(e) => handleInputChange2(index, "bale", e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            {row.entry2 === 0 ?
                                                                <input
                                                                    type="text"
                                                                    placeholder="Bale Mtr"
                                                                    value={row.mtrKg}
                                                                    onChange={(e) => handleInputChange2(index, "mtrKg", e.target.value)}
                                                                /> :
                                                                row.mtrKg}
                                                        </td>
                                                        <td>
                                                            <select
                                                                value={row.rack}
                                                                onChange={(e) => handleInputChange2(index, "rack", e.target.value)}
                                                            >
                                                                <option value="">Select</option>

                                                                {
                                                                    racklist?.data?.map((rack, index) => (
                                                                        <option value={rack.rackNm} key={index}>{rack.rackNm}</option>
                                                                    ))
                                                                }
                                                            </select>


                                                        </td>
                                                        <td>
                                                            {
                                                                row?.lumpRows?.length > 0 ?
                                                                    <>

                                                                        <button type="button" className="lump-btn" onClick={() => handleAddlump(index, row.bale)}>Add Lump</button>
                                                                    </>
                                                                    :

                                                                    <button type="button" className="lump-btn" onClick={() => handleAddlump(index, row.bale)}>Add Lump</button>
                                                            }

                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {openLumpDetails === true &&
                                            <div>
                                                <hr />
                                                {
                                                    openEdit === true ? (
                                                        <LumpMtrTbl
                                                            baleLump={baleRows[lumpId]?.bale}
                                                            handleDeleteRows={handleDeleteLumps}
                                                            handleLumpAddBale={handleLumpAddBale}
                                                            lumpRows={lumpRows}
                                                            lumpTotMtr={lumpTotMtr}
                                                            handleLumpMtr={handleLumpMtr}
                                                            handleLumpSelection={handleLumpSelection}
                                                            handlePerticularLumpAdd={handlePerticularLumpAdd}
                                                            handleClose={handleClose}
                                                            handleLumpColor={handleLumpColor}
                                                        />
                                                    ) : (

                                                        <LumpMtrTbl
                                                            baleLump={baleLump}
                                                            handleDeleteRows={handleDeleteLumps}
                                                            handleLumpAddBale={handleLumpAddBale}
                                                            lumpRows={lumpRows}
                                                            lumpTotMtr={lumpTotMtr}
                                                            handleLumpMtr={handleLumpMtr}
                                                            handleLumpSelection={handleLumpSelection}
                                                            handlePerticularLumpAdd={handlePerticularLumpAdd}
                                                            handleClose={handleClose}
                                                            handleLumpColor={handleLumpColor}
                                                        />
                                                    )
                                                }
                                                <hr />
                                            </div>}

                                        {openLumpDetails !== true &&
                                            <button type="button" className="lump-btn" onClick={() => handleBaleAdd2()}>Bale Add</button>}

                                    </div>
                                }


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default DirectPIEntry2;
